<template>
  <div>
    <el-alert
      title="İletişim Kaydı Yok"
      type="success"
      :closable="false"
      v-if="!Liste">
    </el-alert>
    <el-table
      class="table-xs"
      style="width: 100%"
      width="100%"
      :data="Liste"
      v-if="Liste"
      row-key="id"
      :height="Height">
      <el-table-column
        prop="zaman"
        label="Zaman"
        width="120">
      </el-table-column>
      <el-table-column
        prop="telefon"
        label="Telefon"
        width="100">
      </el-table-column>
      <el-table-column
        prop="durum"
        label="Durum"
        width="100">
      </el-table-column>
      <el-table-column
        prop="icerik"
        label="İçerik"
      >
      </el-table-column>
    </el-table>
  </div>
</template>


<script>
export default {
  props: ["Kisi_id"],
  data() {
    return {
      Liste: null,
      Height: window.innerHeight - 215
    }
  },
  methods: {
    SayfaYukle() {
      if (this.Kisi_id) {
        this.$store.dispatch("Get", {path: 'yonetim/kisi/ekran/' + this.Kisi_id + '/iletisim'})
          .then(response => {
            if (response.Durum === 'OK') {
              this.Liste = response.Data;
              this.lo = false;
            } else {
              this.$message.error(response.Mesaj);
              this.hata = response.Hata;
            }
          });

      }
    },
  },
  created() {
    this.SayfaYukle()
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Pack/Yonetim/kisi/Ekran/KisiIletisim.vue